(ns ui.data-grid.theme
  (:require
   ["ag-grid-community" :refer [colorSchemeDark themeQuartz]]
   [applied-science.js-interop :as j]))

(def light-header-background "#f7f7f9")
(def light-text "#222222")
(def dark-header-background "#1e1e1f")
(def dark-text "#c7c7c7")

(def light
  (j/call themeQuartz :withParams
          #js {:backgroundColor "#ffffff"
               :headerBackgroundColor light-header-background
               :headerTextColor light-text
               :cellTextColor light-text
               :borderColor "#e7e7e9"
               :columnBorder #js {:style "solid" :width 1 :color "#e7e7e9"}
               :headerColumnBorder #js {:style "solid" :width 1 :color "#e7e7e9"}
               :headerColumnBorderHeight "100%"
               :headerFontWeight 400
               :headerFontSize "13px"
               :fontSize "13px"
               :fontFamily "Poppins, sans-serif"
               :cellHorizontalPadding "8px"
               :wrapperBorderRadius "4px"}))

(def dark
  (j/call (j/call themeQuartz :withPart colorSchemeDark) :withParams
          #js {:backgroundColor "#050506"
               :headerBackgroundColor dark-header-background
               :headerTextColor dark-text
               :cellTextColor dark-text
               :borderColor "#313132"
               :columnBorder #js {:style "solid" :width 1 :color "#313132"}
               :headerColumnBorder #js {:style "solid" :width 1 :color "#313132"}
               :headerColumnBorderHeight "100%"
               :headerFontWeight 400
               :headerFontSize "13px"
               :fontSize "13px"
               :fontFamily "Poppins, sans-serif"
               :cellHorizontalPadding "8px"
               :wrapperBorderRadius "4px"}))

(defn for-mode [dark-mode?]
  (if dark-mode? dark light))

(defn header-background [dark-mode?]
  (if dark-mode? dark-header-background light-header-background))

(defn text-color [dark-mode?]
  (if dark-mode? dark-text light-text))

(def kleene-token-params
  {:backgroundColor "var(--color-kleene-background)"
   :headerBackgroundColor "var(--color-kleene-background)"
   :headerTextColor "var(--color-kleene-text-secondary)"
   :cellTextColor "var(--color-kleene-text)"
   :borderColor "var(--color-kleene-layout-border)"
   :rowHoverColor "var(--color-kleene-hover-background)"})
